interface RuntimeConfig {
    API_BASE_URL: string;
    APP_VERSION: string;
}

function isPlaceholder(value: unknown): value is string {
    return typeof value !== "string" || value === "" || value.startsWith("__");
}

function getConfig(): RuntimeConfig {
    const runtimeConfig =
        (window as unknown as { __RUNTIME_CONFIG__?: Partial<RuntimeConfig> }).__RUNTIME_CONFIG__ ?? {};

    const resolve = (
        runtimeValue: string | undefined,
        envFallback: string | undefined,
        defaultValue: string
    ): string => {
        if (runtimeValue && !isPlaceholder(runtimeValue)) return runtimeValue;
        if (envFallback) return envFallback;
        return defaultValue;
    };

    return {
        API_BASE_URL: resolve(runtimeConfig.API_BASE_URL, process.env.REACT_APP_API_URL, "http://localhost:8001"),
        APP_VERSION: resolve("", process.env.REACT_APP_VERSION, "dev"),
    };
}

export const config = getConfig();